import React from "react";
import { AlertCircle, Users, Coffee, ArrowRight, Download } from "lucide-react";

export const INPUT = "w-full px-4 py-3 rounded-xl border border-black/10 bg-white text-[#1A1A1A] placeholder-[#5C5C5C]/60 focus:outline-none focus:ring-2 focus:ring-[#345B73]/30 focus:border-[#345B73] transition-all";

export const Field = ({ label, children, required }) => (
  <label className="block">
    <span className="block text-sm font-medium text-[#1A1A1A] mb-2">{label}{required && <span className="text-[#7A2B33]">*</span>}</span>
    {children}
  </label>
);

export const ErrorBox = ({ msg }) => (
  <div data-testid="booking-error" className="flex items-start gap-2 p-4 rounded-xl bg-red-50 text-red-800 text-sm">
    <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" /> {msg}
  </div>
);

export const SumRow = ({ label, value }) => (
  <div className="flex items-center justify-between px-5 py-3.5">
    <span className="text-sm text-[#5C5C5C]">{label}</span>
    <span className="text-sm font-medium text-[#1A1A1A] text-right">{value}</span>
  </div>
);

export const RoomCard = ({ slug, total, nights, name, tag, desc, img, maxGuests, v, onChoose, testid, onQuote, quoteTestid }) => (
  <div className="flex flex-col sm:flex-row gap-5 p-4 rounded-2xl border border-black/10 hover:border-[#1D3557]/30 transition-all bg-white">
    <div className="sm:w-56 h-44 sm:h-auto rounded-xl overflow-hidden flex-shrink-0">
      <img src={img} alt={name} className="w-full h-full object-cover" />
    </div>
    <div className="flex-1 flex flex-col">
      <span className="text-xs uppercase tracking-widest text-[#345B73]">{tag}</span>
      <h3 className="font-display text-2xl text-[#1A1A1A] mt-0.5">{name}</h3>
      <p className="mt-2 text-sm text-[#5C5C5C] leading-relaxed line-clamp-3">{desc}</p>
      <div className="mt-3 flex items-center gap-2 text-sm text-[#5C5C5C]">
        <Users className="w-4 h-4 text-[#1D3557]" /> {v("maxGuests").replace("{n}", maxGuests)}
        <span className="text-black/20">·</span>
        <Coffee className="w-4 h-4 text-[#2A4B3C]" /> {v("breakfastIncluded")}
      </div>
      <div className="mt-auto pt-4 flex flex-wrap items-end justify-between gap-3">
        <div>
          {total != null && <span className="font-display text-3xl text-[#1A1A1A]">€ {Math.round(total)}</span>}
          <span className="ml-2 text-xs text-[#5C5C5C]">{v("totalStay")}</span>
        </div>
        <div className="flex items-center gap-2">
          <button data-testid={quoteTestid} onClick={onQuote} className="px-4 py-3 rounded-full border border-[#1D3557]/30 text-[#1D3557] text-sm font-medium hover:bg-[#1D3557]/5 transition-all inline-flex items-center gap-1.5">
            <Download className="w-4 h-4" /> {v("downloadQuote")}
          </button>
          <button data-testid={testid} onClick={onChoose} className="px-6 py-3 rounded-full bg-[#1D3557] text-white text-sm font-medium hover:bg-[#345B73] transition-all inline-flex items-center gap-2">
            {v("chooseRoom")} <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  </div>
);
